import { defineCustomElement, getIntegerAttribute, NectaryElement, updateIntegerAttribute } from '../utils';
const templateHTML = '<style>:host{display:block;grid-column:span 12}:host([xl="2"]){grid-column:span 2}:host([xl="3"]){grid-column:span 3}:host([xl="4"]){grid-column:span 4}:host([xl="5"]){grid-column:span 5}:host([xl="6"]){grid-column:span 6}:host([xl="7"]){grid-column:span 7}:host([xl="8"]){grid-column:span 8}:host([xl="9"]){grid-column:span 9}:host([xl="10"]){grid-column:span 10}:host([xl="11"]){grid-column:span 11}:host([xl="12"]){grid-column:span 12}@media only screen and (max-width:1439px){:host{grid-column:span 12}:host([l="2"]){grid-column:span 2}:host([l="3"]){grid-column:span 3}:host([l="4"]){grid-column:span 4}:host([l="5"]){grid-column:span 5}:host([l="6"]){grid-column:span 6}:host([l="7"]){grid-column:span 7}:host([l="8"]){grid-column:span 8}:host([l="9"]){grid-column:span 9}:host([l="10"]){grid-column:span 10}:host([l="11"]){grid-column:span 11}:host([l="12"]){grid-column:span 12}}@media only screen and (max-width:1023px){:host{grid-column:span 8}:host([m="2"]){grid-column:span 2}:host([m="3"]){grid-column:span 3}:host([m="4"]){grid-column:span 4}:host([m="5"]){grid-column:span 5}:host([m="6"]){grid-column:span 6}:host([m="7"]){grid-column:span 7}:host([m="8"]){grid-column:span 8}}@media only screen and (max-width:767px){:host{grid-column:span 4}:host([s="2"]){grid-column:span 2}:host([s="3"]){grid-column:span 3}:host([s="4"]){grid-column:span 4}}</style><slot name="content"></slot>';
const template = document.createElement('template');
template.innerHTML = templateHTML;
defineCustomElement('sinch-grid-item', class extends NectaryElement {
  constructor() {
    super();
    const shadowRoot = this.attachShadow();
    shadowRoot.appendChild(template.content.cloneNode(true));
  }
  get s() {
    return getIntegerAttribute(this, 's', null);
  }
  set s(value) {
    updateIntegerAttribute(this, 's', value);
  }
  get m() {
    return getIntegerAttribute(this, 'm', null);
  }
  set m(value) {
    updateIntegerAttribute(this, 'm', value);
  }
  get l() {
    return getIntegerAttribute(this, 'l', null);
  }
  set l(value) {
    updateIntegerAttribute(this, 'l', value);
  }
  get xl() {
    return getIntegerAttribute(this, 'xl', null);
  }
  set xl(value) {
    updateIntegerAttribute(this, 'xl', value);
  }
});